<template>
  <div class="tv-page">
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["1783"]') }}</span>
      <span slot="secondTit">{{ $t('message["1783"]') }}</span>
    </crumb-tit>

    <a-alert
      type="info"
      class="custom-alert clearfix"
    >
      <div
        slot="description"
      >
        <i class="iconfont iconicon-test68-copy fs-info fl" />
        {{ $t('message["1785"]') }}
        <a
          href="https://help.westartrack.com/article/d_5f6ae9ec200d5c005301be57.html"
          target="_blank"
          class="fr"
        >{{ $t('message[86]') }}</a>
      </div>
    </a-alert>
    <a-tabs
      :active-key="activeKey"
      tab-position="top"
      :animated="false"
      @change="tabCallback"
    >
      <a-tab-pane
        key="1"
        :tab="$t('message[1787]')"
      />
      <!-- 组合 -->
      <a-tab-pane
        key="2"
        :tab="$t('message[1926]')"
        force-render
      />
    </a-tabs>
    <router-view />
  </div>
</template>

<script>
import CrumbTit from '@/components/pc/config/CrumbTit'

export default {
  components: {
    CrumbTit
  },
  data () {
    return {
      activeKey: '1'
    }
  },
  computed: {
    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      document.title = this.$t('message["1783"]') + projectname + comname
      return this.$t('message["1783"]') + projectname + comname
    }
  },
  watch: {
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    },
    $route: {
      handler (to) {
        let key = '1'
        switch (to.name) {
          case 'configTvList':
            key = '1'
            break
          case 'configTvGroupList':
            key = '2'
            break
          default:
            key = '1'
            break
        }
        this.activeKey = key
      },
      immediate: true
    }
  },

  methods: {
    tabCallback (key) {
      let routeName
      if (key === '1') {
        routeName = 'configTvList'
      } else if (key === '2') {
        routeName = 'configTvGroupList'
      }
      this.$router.push({
        name: routeName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tv-page::v-deep {
  .crumb-title {
    margin-bottom: 16px;
  }
  .custom-alert.ant-alert.ant-alert-with-description {
    margin-bottom: 16px;
  }
  .ant-alert-description {
    width: 100%;
  }
  .ant-tabs {
    margin-top: 24px;
  }
  .ant-tabs-bar {
    margin-bottom: 24px;
    border-top: solid 1px #ebebeb;
    border-bottom: 0 none;
  }
  .ant-tabs-nav {
    .ant-tabs-tab {
      margin-right: 24px;
      padding: 8px 2px;
      font-size: 18px;
      font-weight: bold;
      line-height: 32px;
    }
  }
}
</style>
